export default __webpack_public_path__ + "static/media/Logo-circle.991e1e9b.png";